/**
 * @author      luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright   Copyright (c) 2022, Zumper
 * @description CityMarker styles
 */

import { type Theme, css } from '@emotion/react'
import { Z_INDEX_GROUP_2, Z_INDEX_GROUP_3 } from '@zcode-ui/themes'

export const outerContainer = css`
  cursor: pointer;

  &:hover,
  &.hover {
    z-index: ${Z_INDEX_GROUP_3} !important;
  }

  &:active {
    z-index: ${Z_INDEX_GROUP_3} !important;
  }
`

export const container = ({ colors, typography }: Theme) => css`
  position: relative;
  z-index: ${Z_INDEX_GROUP_2};

  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 125px;
  height: 48px;
  padding: 5px 10px;

  color: ${colors?.backgroundLightest};
  font-weight: ${typography?.fontWeightBold};
  font-size: ${typography?.fontSize14};
  font-family: var(--chakra-fonts-body);
  line-height: 1em;
  text-align: center;

  background-color: ${colors?.accent};
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);

  user-select: none;

  &:hover,
  &.hover {
    .is-desktop {
      background-color: ${colors?.secondaryHover};
    }
  }
`

export const textContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  max-width: 118px;
  height: 100%;
  padding-left: 10px;
`

export const textContainerLarge = css`
  justify-content: space-between;
  max-width: 100%;
  height: 50px;
`

export const text = ({ colors, typography }: Theme) => css`
  max-width: 100%;
  overflow: hidden;

  color: ${colors?.backgroundLightest};
  font-weight: ${typography?.fontWeightBold};
  white-space: nowrap;
  text-align: left;
  text-overflow: ellipsis;
`
export const textLarge = css`
  font-size: 18px;
  line-height: 1.5em;
`

export const subText = ({ colors, typography }: Theme) => css`
  color: ${colors?.backgroundLightest};
  font-weight: ${typography?.fontWeightRegular};
`

export const subTextLarge = css`
  font-size: 16px;
  line-height: 1.5em;
`
